import { useModulesStore } from '@/stores/modules.ts'
import type { ModuleStatus } from '@shared/types'

/**
 * Hook to get a module's status (beta/stable).
 *
 * Usage:
 *   const { status, isBeta } = useModuleStatus('kalender')
 */
export function useModuleStatus(moduleId: string): { status: ModuleStatus; isBeta: boolean } {
  const status = useModulesStore((s) => s.getStatus(moduleId))
  const isBeta = status === 'beta'
  return { status, isBeta }
}
